import { Component, Input } from '@angular/core';
import { FormViewState } from 'src/app/common/models/form-view-state';
import { LogSignatureComponent } from '../../form-history-signatures/log-signature/log-signature.component';

@Component({
  selector: 'form-history-scf',
  templateUrl: './form-history-scf.component.html',
  styleUrls: ['./form-history-scf.component.scss'],
})
export class FormHistoryScfComponent {

  @Input() originalBody: any;
  @Input() update: any;
  @Input() status?: FormViewState;

}
